import React from 'react';
import Styles from './styles.module.css';
import { FaRegLightbulb } from "react-icons/fa";

type DefaultTitleProps = {
  title: string;
  hint?: { title: string; text?: string };
  setHintText?: (value: any) => void;
  valueLength?: number;
  maxLength?: number;
};

const DefaultTitle: React.FC<DefaultTitleProps> = ({ title, hint, setHintText, valueLength, maxLength }) => {
  return (
    <div className={Styles.title}>
      <div className={Styles.title_left}>
        <p className={Styles.title_text}>{title}</p>
        {hint?.title && setHintText && (
          <FaRegLightbulb className={Styles.title_hint} onClick={() => setHintText(hint)} />
        )}
      </div>
      <p className={Styles.title_length}>
        {valueLength} {valueLength !== undefined && ( "/" )} {maxLength}
      </p>
    </div>
  );
};

export default DefaultTitle;
